import { isGenesGtpHeatmapEnabled } from '@/config/release263Features';

const ASSOCIATION_GRAPH_TABS = new Set(['GDA', 'VDA', 'DDA']);

export type GraphTabVisibilityOptions = {
  enableGenesHeatmap?: boolean;
  searchItemCount?: number;
};

export function canShowGenesHeatmap(view: string, options: GraphTabVisibilityOptions = {}): boolean {
  const enableGenesHeatmap = options.enableGenesHeatmap ?? isGenesGtpHeatmapEnabled;
  const searchItemCount = options.searchItemCount ?? 0;
  return enableGenesHeatmap && String(view ?? '').toUpperCase() === 'GENES' && searchItemCount > 1;
}

export function searchTabHasGraphs(
  view: string,
  tab: string,
  options: GraphTabVisibilityOptions = {},
): boolean {
  const normalizedView = String(view ?? '').toUpperCase();
  const normalizedTab = String(tab ?? '').toUpperCase();

  if (normalizedView === 'ALL' || normalizedView === 'CHEMICALS') return false;
  if (ASSOCIATION_GRAPH_TABS.has(normalizedTab)) return true;

  return normalizedTab === 'GENES' && canShowGenesHeatmap(view, options);
}

export function getVisibleSearchTabs<T extends { key: string }>(
  tabList: T[],
  selectedView: 'tables' | 'graphs',
  view: string,
  options: GraphTabVisibilityOptions = {},
): T[] {
  if (selectedView !== 'graphs') return tabList;

  if (canShowGenesHeatmap(view, options)) return tabList;

  return tabList.slice(0, -1);
}
